module.exports = __webpack_public_path__ + "img/4635.fa980654.jpg";